import React, { useEffect, useState } from 'react';
import Lottie from "lottie-react";
import loginLottie from "../static/login-asset/wm-login-lottie.json";
import Logo from "../common-components/Logo";
import { AppConstants } from "../constants";
import redirectingImg from "../static/images/redirecting.gif";

const Relogin: React.FC = () => {
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let redirectUrl = params.get("target_url");
    if (redirectUrl) {
      redirectUrl = decodeURIComponent(decodeURIComponent(redirectUrl));
      setRedirectUrl(redirectUrl);

      setTimeout(() => {
        window.location.href = redirectUrl as string;
      }, 3000);
    }
   
  }, []);


  return (
    <div className="login-container">
      <div className="row">
        <div className="login-left-section col-xs-12 col-sm-5 col-md-5 col-lg-5">
          <div className="login-content">
            <Logo />
            <div className="form-container login">
              <div className="form-title">
                <h1>
                  Redirecting to WaveMaker Home
                  <span className="loadingSpinner" style={{ marginLeft: '10px' }}>
                    <img
                      src={redirectingImg}
                      alt="Redirecting to"
                      title="Loading"
                      style={{ width: '24px', height: '24px' }}
                    />
                  </span>
                </h1>
              </div>
              <div className="form-row">
                <div className="row">
                  <div className="col-sm-12">
                    <p style={{ fontWeight: 500, fontSize: "14px", marginBottom: "12px" }}>Signing into WaveMaker Home</p>
                    {redirectUrl && (
                      <p style={{ fontWeight: 400 }}>
                        Redirecting to :<br />
                        <span style={{ textDecoration: "underline", textUnderlineOffset: "3px", marginTop: "4px", display: "block", wordBreak: "break-all", color: "rgb(70 170 244)" }}>{redirectUrl}</span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="copyright-text">
            © {currentYear} WaveMaker. All Rights Reserved
          </p>
        </div>
        <div className="login-right-section col-xs-12 col-sm-7 col-md-7 col-lg-7">
          <div className="right-content-wrapper">
            <h3 className="right-section-title">
              {AppConstants.CAROUSELTITLE}
            </h3>
            <Lottie
                animationData={loginLottie}
                loop={true}
                className="lottie-animation"
              />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Relogin;